<template>
  <base-dialog class="option-set-dialog" :visible.sync="visible" show-close>
    <template v-slot:header>编辑选项集</template>
    <div class="input">
      <div class="tab">名称</div>
      <el-input v-model="name" placeholder="选项集"></el-input>
    </div>
    <div class="input">
      <div class="tab">选项</div>
      <div style="width:100%">
        <div style="width:100%;margin-top: 5px;display:flex">
          <span style="margin-right:5px;color:#409eff;">颜色</span>
          <el-switch
            v-model="useColor"
            class="switchStyle"
            @change="addColor(editControl)"
          ></el-switch>
        </div>
        <draggable
          class="option-setting"
          handle=".el-input-group__prepend"
          v-model="options"
          :animation="50"
        >
          <template>
            <div v-for="(option, i) in options" :key="i">
              <el-input
                class="input-group"
                v-model="option.label"
                @input="option.value = option.label"
              >
                <i class="el-icon-rank" slot="prepend"></i>
                <div slot="append" style="display: flex; line-height: 5px">
                  <el-popover v-if="useColor" placement="top" v-model="colorVisible[i]">
                    <div style="text-align: right; margin: 0">
                      <el-button
                        v-for="(item, index) in colorList"
                        :key="index"
                        :class="item"
                        size="mini"
                        circle
                        @click="chooseColor(i, item)"
                      ></el-button>
                    </div>
                    <el-button
                      slot="reference"
                      :class="[option.color, 'option-color']"
                      size="mini"
                      circle
                    ></el-button>
                  </el-popover>
                  <el-button
                    icon="el-icon-delete"
                    @click="deleteOption(i)"
                    style="float: right; margin: -7px -20px"
                    size="mini"
                    type="danger"
                  ></el-button>
                </div>
              </el-input>
            </div>
          </template>
          <template slot="footer">
            <div style="margin-top:5px">
              <el-button
                type="success"
                size="mini"
                icon="el-icon-plus"
                :round="true"
                @click="addOptions()"
              >
                增加选项
              </el-button>
            </div>
          </template>
        </draggable>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="updateOptionSet">确 定</el-button>
    </span>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import draggable from "vuedraggable"
import { updateOptionSet, getOptionSet, createOptionSet } from "@/api/sheet/sheetOptionSet"
import { colorList, defaultOptions } from "./static"

export default {
  name: "option-set-dialog",
  components: {
    draggable,
    BaseDialog
  },
  props: {
    optionSetId: String,
    appId: String
  },
  data() {
    return {
      visible: false,
      editControl: null,
      optionSet: null,
      options: [],
      colorList,
      name: "",
      colorVisible: [],
      useColor: false
    }
  },
  methods: {
    open() {
      if (this.optionSetId == "") {
        this.optionSet = {
          name: "",
          options: defaultOptions
        }
        this.editControl = this.initialDefaultVal(this.optionSet)
      } else {
        getOptionSet(this.optionSetId)
          .then(optionSet => {
            this.optionSet = optionSet
            this.editControl = this.initialDefaultVal(this.optionSet)
          })
          .catch(() => {
            this.$message.error("请求出错，请刷新重试！")
          })
      }
      this.visible = true
    },
    initialDefaultVal(optionSet) {
      this.useColor = Boolean(optionSet.options[0].color)
      if (this.useColor) {
        for (let i = 0; i < optionSet.options.length; i++) {
          this.colorVisible[i] = false
          if (!this.colorList.includes(optionSet.options[i].color)) {
            optionSet.options[i].color = this.colorList[i % 6]
          }
        }
      }
      this.options = optionSet.options
      this.name = optionSet.name
      return optionSet
    },
    // 添加选项
    addOptions() {
      let label = "选项" + (this.editControl.options.length + 1)
      this.editControl.options.push({
        label,
        value: label,
        color: this.useColor ? this.colorList[this.editControl.options.length % 6] : null
      })
    },
    deleteOption(i) {
      let editControl = this.editControl
      if (editControl.options.length <= 1) return
      this.editControl.options.splice(i, 1)
    },
    addColor(editControl) {
      if (!this.useColor) {
        for (let i = 0; i < editControl.options.length; i++) {
          editControl.options[i].color = null
        }
      } else {
        for (let j = 0; j < editControl.options.length; j++) {
          editControl.options[j].color = this.colorList[j % 5]
        }
      }
    },
    chooseColor(i, color) {
      let optionSet = this.optionSet
      optionSet.options[i].color = color
      this.colorVisible.splice(i, 1, false)
    },
    updateOptionSet() {
      if (this.optionSetId != "") {
        let optionSet = {
          appId: this.appId,
          id: this.optionSet.id,
          name: this.name,
          options: this.options
        }
        updateOptionSet(optionSet)
          .then(res => {
            this.$emit("submit", this.options)
            this.visible = false
          })
          .catch(() => {
            this.$message.error("请求出错，请刷新重试！")
          })
      } else {
        let optionSet = {
          name: this.name,
          options: this.options
        }
        createOptionSet(optionSet, this.appId)
          .then(res => {
            this.$emit("submit", this.options)
            this.visible = false
          })
          .catch(() => {
            this.$message.error("请求出错，请刷新重试！")
          })
      }
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.option-set-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px 15px !important;
  }
  .tab {
    font-size: 14px;
    width: 62px;
    margin-top: 5px;
    color: #3d3140;
  }
  .input {
    margin-bottom: 10px;
    display: flex;
  }
  ::v-deep .el-dialog {
    width: 458px !important;
  }
  .option-setting {
    ::v-deep {
      .el-input-group__append {
        .el-radio__label {
          display: none;
        }
      }
    }
  }
  .input-group {
    margin-top: 5px;
  }
  .option-color {
    margin-left: 1px;
    margin-right: 20px;
    border: 0px;
  }
}
</style>
